module.exports = __webpack_public_path__ + "static/media/5.65ce1977.wav";